import { OrganizationKind } from "@digits-graphql/frontend/graphql-bearer"

type OrganizationWithKind = {
  kind: OrganizationKind
}

/**
 * Pure function to determine if the given organization is an accounting firm.
 */
export function isOrgAccountingFirm<T extends OrganizationWithKind>(
  organization: T | undefined
): boolean {
  if (!organization) {
    return false
  }

  return (
    organization.kind === OrganizationKind.AccountingFirm ||
    organization.kind === OrganizationKind.SandboxAccountingFirm
  )
}

/**
 * Pure function to determine if the given organization is an accounting firm but excludes
 * sandbox accounting firms.
 */
export function isOrgNonSandboxAccountingFirm<T extends OrganizationWithKind>(
  organization: T | undefined
): boolean {
  if (!organization) {
    return false
  }

  return organization.kind === OrganizationKind.AccountingFirm
}

/**
 * Pure function to determine if the given organization is a sandbox accounting firm.
 */
export function isOrgSandboxAccountingFirm<T extends OrganizationWithKind>(
  organization: T | undefined
): boolean {
  if (!organization) {
    return false
  }

  return organization.kind === OrganizationKind.SandboxAccountingFirm
}
